import { FaTiktok } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { AiFillYoutube, AiFillLinkedin, AiFillFacebook, AiFillInstagram } from "react-icons/ai";

import iconApple from "../../assets/images/loja_apple.png";
import IconGooglePlay from "../../assets/images/loja_googleplay.png";

function ShareButton() {
  const { t } = useTranslation();

  return (
    <>
      <div className="share">
        <h2>{t("SHARE")}</h2>
        <span className="share-lingo">
          <a rel="noreferrer" href="https://www.instagram.com/lingoforme/" target="_blank">
            <AiFillInstagram size={24} color="#004FFF" />
          </a>
          <a rel="noreferrer" href="https://www.facebook.com/lingoforme" target="_blank">
            <AiFillFacebook size={24} color="#004FFF" />
          </a>
          <a rel="noreferrer" href="https://www.tiktok.com/@lingoforme" target="_blank">
            <FaTiktok size={24} color="#004FFF" />
          </a>
          <a rel="noreferrer" href="https://cl.linkedin.com/company/lingoforme" target="_blank">
            <AiFillLinkedin size={24} color="#004FFF" />
          </a>
          <a rel="noreferrer" href="https://www.youtube.com/c/LingoforMe" target="_blank">
            <AiFillYoutube size={24} color="#004FFF" />
          </a>
        </span>
      </div>
      <div className="lojas">
        <a rel="noreferrer" href="https://apps.apple.com/br/app/lingofor-me/id1464904000" target="_blank">
          <img src={iconApple} alt="loja apple" />
        </a>
        <a rel="noreferrer" href="https://play.google.com/store/apps/details?id=me.lingofor.app" target="_blank">
          <img src={IconGooglePlay} alt="loja android" />
        </a>
      </div>
    </>
  );
}

export default ShareButton;
